import { c as _c } from "react/compiler-runtime";
import { useDeviceDetect } from "@/hooks/use-user-agent";
import { Key } from "./Key";
export function ModifierKey() {
  const $ = _c(2);
  const {
    isWindows
  } = useDeviceDetect();
  const modifier = isWindows ? "CTRL" : "\u2318";
  let t0;
  if ($[0] !== modifier) {
    t0 = <Key>{modifier}</Key>;
    $[0] = modifier;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}